import type { RouteObject } from 'react-router-dom'
import { useRoutes } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Layout from '@/components/Layout'
import Home from '@/pages/Home'
import CalculatorPage from '@/pages/CalculatorPage'
import Blog from '@/pages/Blog'
import BlogPost from '@/pages/BlogPost'
import Faq from '@/pages/Faq'
import About from '@/pages/About'
import Legal from '@/pages/Legal'
import NotFound from '@/pages/NotFound'
import { CATEGORIES, POSTS } from '@/data/blog'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'calculator', element: <CalculatorPage /> },
      { path: 'blog', element: <Blog /> },
      ...CATEGORIES.map(c => ({ path: `blog/category/${c.slug}`, element: <Blog category={c.slug} /> })),
      ...POSTS.map(p => ({ path: `blog/${p.slug}`, element: <BlogPost slug={p.slug} /> })),
      { path: 'faq', element: <Faq /> },
      { path: 'about', element: <About /> },
      { path: 'privacy', element: <Legal doc="privacy" /> },
      { path: 'terms', element: <Legal doc="terms" /> },
      { path: 'disclaimer', element: <Legal doc="disclaimer" /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]

function App() {
  const element = useRoutes(routes)
  return (
    <>
      {element}
      <Toaster position="bottom-center" toastOptions={{ style: { fontWeight: 600 } }} />
    </>
  )
}

export default App
